import { get, post } from '@/api/core'

export namespace notification {
  export function one(p: { noticeType: 'system' | 'corp'; noticeId: number }) {
    return get('/notice/one', p)
  }

  export function list(p: { pageNo: number; pageSize: number; noticeType: 'system' | 'corp' }) {
    return get<{
      hasNext: boolean
      hasNoReadNotice: boolean
      objects: Models.Notification[]
      pageNo: number
      pageSize: number
      totalCount: number
    }>('/notice/list', p)
  }

  export function read(p: { noticeType: 'system' | 'corp'; noticeId: number }) {
    return post('/notice/read', {}, p)
  }

  /** 获取是否有未读消息 */
  export function hasUnRead() {
    return get<{
      corpNotReadCount: number
      systemNotReadCount: number
    }>('/notice/read/check')
  }
}
